import React from "react";
import { useFela } from "react-fela";

import { useTheme } from "@/hooks/useTheme";
import { Heading } from "@/components/Heading";
import { Image } from "@/components/Image";

import { IInspectorFeatureItem } from "../types";

export const FeatureItem: React.FC<IInspectorFeatureItem> = ({
  title,
  description,
  image,
  imageWrapperStyle,
}) => {
  const { colors } = useTheme();
  const { css } = useFela();

  return (
    <div
      className={css({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
      })}
    >
      <div
        className={css({
          borderRadius: "12px",
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          width: "100%",
          padding: "40px 0 0",
          overflow: "hidden",
          ...imageWrapperStyle,
        })}
      >
        <Image
          customStyle={{
            width: "100%",
            margin: "0 auto",
            maxWidth: 360,
            objectPosition: "center bottom",
            filter: "drop-shadow(0px -10px 20px rgba(16, 5, 48, 0.08))",
          }}
          {...image}
        />
      </div>

      <div className={css({ padding: "40px 10px" })}>
        <Heading
          as="h3"
          customStyle={{
            textAlign: "center",
            fontSize: 24,
            lineHeight: "32px",
            marginBottom: 12,
            color: colors.DARK_GREY,
            fontWeight: 700,
          }}
        >
          {title}
        </Heading>

        <p
          className={css({
            textAlign: "center",
            fontSize: 16,
            lineHeight: "24px",
            color: colors.GRAY,
          })}
        >
          {description}
        </p>
      </div>
    </div>
  );
};
